// src/components/ui/build/componentCards/pnlCache.ts

interface PnLCacheEntry {
    chartData: any[];
    errorMsg: string | null;
}

const cache = new Map<string, PnLCacheEntry>();

export function getPnLCache(nodeId: string): PnLCacheEntry | undefined {
    return cache.get(nodeId);
}

export function setPnLCache(nodeId: string, chartData: any[], errorMsg: string | null): void {
    cache.set(nodeId, { chartData, errorMsg });
}

export function clearPnLCache(nodeId: string): void {
    cache.delete(nodeId);
}
